import { z } from "zod";

export const forgotPasswordValidationSchema = z.object({
  email: z
    .string({ required_error: "O e-mail é obrigatório" })
    .min(1, "O e-mail é obrigatório")
    .email("O e-mail é inválido"),
});

export type ForgotPasswordFormInput = z.input<
  typeof forgotPasswordValidationSchema
>;
